<template>
  <card :title="localization('Edit Roles & Roles Permissions')">
    <card>
      <div class="row" style="display: flex; align-items: center">
        <div class="col-sm-9">
          <el-select
            v-model="roles"
            multiple
            filterable
            class="select-default"
            :placeholder="localization('Select Role')"
            style="width: 100%; color: black"
          >
            <el-option
              v-for="(role, id) in $store.getters['roles/roles']"
              :key="id"
              :label="localization(role.name)"
              :value="`${role.id}`"
            >
              <span style="float: right; color: #8492a6; font-size: 13px">
                {{ localization(role.name) }}
                <i class="el-icon-user-solid"></i>
              </span>
            </el-option>
          </el-select>
        </div>
        <div class="col-sm-3">
          <el-button
            type="success"
            @click="save"
            icon="el-icon-folder-checked"
            style="width: 100%"
          >
            {{ localization("Update Role") }}
          </el-button>
        </div>
      </div>
    </card>

    <div>
      <div class="row">
        <div
          class="col-sm-4"
          v-for="(group, key) in $store.getters['roles/permissionsGroups']"
          :key="key"
        >
          <el-card
            v-loading="$store.getters['roles/rolesLoad'] || isLoadingRolePermissions"
            :header="localization(key)"
            class="mb-3"
          >
            <el-checkbox-group
              v-for="(permission, id) in group"
              :key="id"
              v-model="Permissions"
              style="text-align: initial"
            >
              <el-checkbox
                disabled
                :label="`${permission.id}`"
                :key="permission.id"
                style="width: 100%"
              >
                {{ localization(permission.name) }}
              </el-checkbox>
            </el-checkbox-group>
          </el-card>
        </div>
      </div>
    </div>
  </card>
</template>

<script>
import Roles from "@/api/roles";
const rolesApi = new Roles();

export default {
  name: "show",
  data() {
    return {
      options: {},
      roles: [],
      Permissions: [],
      permissions: [],
      isLoadingRolePermissions: false,
      isInitialLoad: true
    };
  },
  mounted() {
    this.Refresh();
  },
  watch: {
    roles(newRoles) {
      if (!this.isInitialLoad) {
        this.loadPermissionsForRoles(newRoles);
      }
    }
  },
  methods: {
    Refresh() {
      this.isInitialLoad = true;
      this.$store.dispatch("roles/getRoles");
      this.$store
        .dispatch("roles/getUserRolesPermissions", this.$route.params.id)
        .then(_ => {
          this.roles = this.$store.getters["roles/userRoles"] || [];
          this.loadPermissionsForRoles(this.roles);
          this.$nextTick(() => {
            this.isInitialLoad = false;
          });
        });
    },
    loadPermissionsForRoles(roleIds) {
      if (!roleIds || roleIds.length === 0) {
        this.Permissions = [];
        return;
      }
      this.isLoadingRolePermissions = true;
      Promise.all(roleIds.map(id => rolesApi.get(id)))
        .then(responses => {
          const permSet = new Set();
          responses.forEach(res => {
            if (res && res.permissions) {
              Object.keys(res.permissions).forEach(permId => {
                permSet.add(`${permId}`);
              });
            }
          });
          this.Permissions = Array.from(permSet);
        })
        .catch(err => {
          console.error("Error loading permissions for roles:", err);
        })
        .finally(() => {
          this.isLoadingRolePermissions = false;
        });
    },
    save() {
      this.$store
        .dispatch("roles/updateUserRolesPermissions", {
          id: this.$route.params.id,
          data: { roles: this.roles, permissions: [] }
        })
        .then(_ => {
          this.$message({
            message: this.localization("Role updated successfully"),
            type: "success"
          });
          this.Refresh();
        });
    }
  }
};
</script>

<style scoped>
::v-deep .select-default .el-select__tags .el-tag {
  color: #888 !important;
}
</style>

